import { useEffect, useState } from 'react';
import debounce from 'lodash.debounce';

const useWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = debounce(() => {
      setWidth(window.innerWidth);
    }, 100);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = width <= 667;
  const isSmallTablet = width <= 900;
  const isTablet = width <= 1042;
  const isSmallLaptop = width <= 1400;
  const isSmallerLaptop = width <= 1440;
  return {
    width,
    isMobile,
    isSmallTablet,
    isTablet,
    isSmallLaptop,
    isSmallerLaptop,
  };
};

export default useWindowWidth;
